import { Controller } from '@hotwired/stimulus'

import $ from 'jquery'
window.jQuery = $ // jQuery attaches itself as `$` to `window` when imported, but not as `jQuery`… unfortunately, importing Select2 i18n requires it 😞

import select2 from 'select2'
select2(window, $)

export default class extends Controller {
  // Events triggered by Select2 (see https://select2.org/programmatic-control/events)
  // This Stimulus controller will forward them as native events too.
  //
  static eventTypes = [
    'change',
    'change.select2',
    'select2:closing',
    'select2:close',
    'select2:opening',
    'select2:open',
    'select2:selecting',
    'select2:select',
    'select2:unselecting',
    'select2:unselect',
    'select2:clearing',
    'select2:clear'
  ]

  connect() {
    this.i18n = window.I18n?.controllers?.select2 || {}

    $(() => {
      this.element.classList.add('select2')
      this.forwardJqueryEventsAsNativeEvents()

      Promise.all([
        import('select2/dist/js/i18n/en'),
        import('select2/dist/js/i18n/fr'),
        import('select2/dist/js/i18n/es'),
        import('select2/dist/js/i18n/de')
      ]).then(_ => {
        $(this.element).select2(this.options)
      })

      this.setSearchFieldsPlaceholder(this.i18n.search_field_placeholder)
    })
  }

  get modal() {
    if (this._modal === undefined) this._modal = this.element.closest('.modal')

    return this._modal
  }

  get options() {
    const options = {
      minimumResultsForSearch: 2
    }

    if (this.modal) options.dropdownParent = $(this.modal)

    return options
  }

  setSearchFieldsPlaceholder(value) {
    const scope = this.modal || document

    $(this.element).on('select2:open', _event =>
      scope
        .querySelectorAll('.select2-search__field')
        .forEach(searchField => searchField.setAttribute('placeholder', value))
    )
  }

  forwardJqueryEventsAsNativeEvents() {
    $(this.element).on(this.constructor.eventTypes.join(' '), jqueryEvent => {
      if (jqueryEvent.detail?.forwardedJqueryEvent) return // prevent forwarding an already forwarded event

      let nativeEvent = new CustomEvent(jqueryEvent.type, {
        bubbles: true,
        detail: { forwardedJqueryEvent: jqueryEvent }
      })

      jqueryEvent.target.dispatchEvent(nativeEvent)
    })
  }
}
